import { getProjectInfo } from '@/api/bidEvaluationCommittee/api'
import { getProjectDetail } from '@/api/agent/api'
import { getProjectTypeName } from '@/utils/base'
//  入参

export const getBidderFlowTitle = async (sectionCode) => {
    try {
        const res = await getProjectInfo(sectionCode)
        if (res && res.code === 200 && res.data) {
            const { projectCode, projectName } = res.data
            return `投标人流程——招标项目编号：${projectCode || ''}　招标项目名称：${projectName || ''}`
        }
        return '投标人流程——招标项目编号：　招标项目名称：'
    } catch (e) {
        return '投标人流程——招标项目编号：　招标项目名称：'
    }
}


// 招标代理的头部
export const loadProjectDetail = async (projectCode) => {
    try {
        const res = await getProjectDetail({ projectCode: projectCode })
        if (res && res.code === 200 && res.data) {
            const pageTitle = generatePageTitle(res.data)
            return pageTitle
        }
        return ''
    } catch (e) {
        console.error('获取项目详情失败:', e)
        return ''
    }
}

export const generatePageTitle = (projectData) => {
    const projectTypeName = getProjectTypeName(projectData.projectType)
    return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
}